import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { connect } from 'react-redux';
import { LEFTRIGHT_PADDING } from "../config/style.config";
//
import DangerZoneWatchChart from '../components/charts/DangerZoneWatchChart'
import DropDown from '../components/DropdownMenu';
import DangerZoneWatchAlertList from "../components/watchPage/DangerZoneWatchAlertList";
import PageSelector from "../components/PageSelector"
//svg
import TitleLeftSvg from '../svgs/TitleLeftSvg'
import SmallSearchSvg from '../svgs/watchPage/SmallSearchSvg'
import CopyLink from "../components/CopyLink";
//
import { fetchWatchEvent } from "../services/watches.service";
import { updateManyEventsByFilter } from '../services/events.service'
//
import { handleFilterDate, yearMonthDay } from "../actions/actionsDateTime";
import { REFRESH_INTERVAL } from "../config";
import { createConfigRecord, editConfigRecord, fetchConfig } from "../services/config.service";

const limit = 10

function SmartWatch(props) {
    const fromRef = useRef(null)
    const toRef = useRef(null)
    const [searchParams, setSearchParams] = useSearchParams();
    const [totalItem, setTotalItem] = useState(1)
    const [popType, setPopType] = useState(undefined)
    const totalPage = Math.ceil(totalItem / limit) || 1
    const page = parseInt(searchParams.get('page')) || 1
    const filterName = searchParams.get('search')
    const filterDate = (searchParams.get('date') || 'Today')
    const filterFrom = searchParams.get('from')
    const filterTo = searchParams.get('to')
    const navigate = useNavigate();
    const [ChartData, setChartData] = useState([])
    const [isHoverChart, setisHoverChart] = useState(false)
    //
    useEffect(() => {
        const timer = setTimeout(fetchData, 500)
        const interval = setInterval(fetchData, REFRESH_INTERVAL)
        return () => {
            clearTimeout(timer)
            clearInterval(interval)
        }
    }, [searchParams])


    const [towerCraneDangerZoneConfig, setTowerCraneDangerZoneConfig] = useState({})
    useEffect(() => {
        fetchConfigWithKey()
    }, [])
    async function fetchConfigWithKey() {
        let result = await fetchConfig(props.token.token, { key: 'watch-tower-crane-danger-zone' }, { limit: 1 })
        if (result.errno) return
        if (result.count === 0) {
            await createConfigRecord(props.token.token, { key: 'watch-tower-crane-danger-zone', value: { distanceThreshold: 100 } })
        } else {
            setTowerCraneDangerZoneConfig(result.result[0])
        }
    }


    async function fetchData() {
        // formatDataForChart()
        const filter = { type: 'WATCH_DNG_ZONE' }
        let result = await fetchConfig(props.token.token, { key: 'watch-tower-crane-danger-zone' }, { limit: 1 })
        if(result.result.length > 0){
            let config = result.result[0]
            if(config.value && config.value.sensors){
                let sensorsId = config.value.sensors.map(item => item.sensorId)
                filter['sensors.id']= {"$in": sensorsId}
            }
        }
        
        if (filterName) filter['$or'] = [{ name: { "$regex": filterName } }, { deviceID: { "$regex": filterName, "$options": 'i' } }]
        if (filterDate) filter['time'] = handleFilterDate(filterDate)
        if (filterFrom && filterTo) filter['time'] = handleFilterDate('', filterFrom, filterTo)
        filter["projectId"] = props.control.projectId
        const res = await fetchWatchEvent(props.token.token, filter, { limit, skip: limit * (page - 1) })
        if (res.errno) return
        setTotalItem(res.count)
        setChartData(res.result)

        const toPage = Math.ceil(res.count / limit) || 1
        if (page > toPage) handleParamChange('page', 1)
    }
    const handleSelectPage = (num) => () => {
        handleParamChange('page', num)
    }
    function handleParamType(item) {
        searchParams.delete('type')
        if (item !== 'All') searchParams.set('type', item)
        searchParams.delete('page')
        setSearchParams(searchParams)
    }
    function handleParamChange(key, val) {
        searchParams.delete(key)
        if (key === 'clearDate') {
            searchParams.delete('from')
            searchParams.delete('to')
            searchParams.delete('date')
            fromRef.current.value = ""
            toRef.current.value = ""
        }
        if (['from', 'to'].includes(key)) searchParams.delete('date')
        if (key === 'date') {
            searchParams.delete('from')
            searchParams.delete('to')
        }
        if (key !== 'page') {
            searchParams.delete('page')
        }
        if (val !== '' && key !== 'clearDate') searchParams.set(key, val)
        setSearchParams(searchParams)
    }
    function handleDateChange(val) {
        if (val !== 'Select Date') return handleParamChange('date', val)
        setPopType('date')

    }

    const handleResolveAll = async () => {
        const userConfim = await window.confirm('Resolve all alerts?')
        if (!userConfim) return;
        const filter = {
            projectId: props.control?.projectId,
            device: 'WATCH',
            type: 'WATCH_DNG_ZONE',
        }
        if (filterDate) filter['time'] = handleFilterDate(filterDate)
        if (filterFrom && filterTo) filter['time'] = handleFilterDate('', filterFrom, filterTo)
        const data = {
            condition: 'Resolved'
        }
        const res = await updateManyEventsByFilter(props.token?.token, filter, data)
        if (res.errno) return alert(res.message || 'error')
        fetchData()
    }

    const [isAddingSensor, setIsAddingSensor] = useState(false)
    const [newSensor, setNewSensor] = useState({})
    const handleStartAddSensor = () => {
        setIsAddingSensor(true)
        setNewSensor({ sensorId: '', status: 'SLEEP', lastUpdated: new Date().getTime() })
    }
    const handleConfirmAddSensor = async () => {
        if (!newSensor.sensorId) return alert('Please enter sensor ID')
        const updatedSensors = [...(towerCraneDangerZoneConfig.value.sensors || []), newSensor]
        const newConfig = {
            value: {
                ...towerCraneDangerZoneConfig.value,
                sensors: updatedSensors
            }
        }
        const res = await editConfigRecord(props.token.token, towerCraneDangerZoneConfig._id, newConfig)
        if (res.errno) return alert(res.message || 'Error')
        setIsAddingSensor(false)
        fetchConfigWithKey()
    }
    const [isEditingSensor, setIsEditingSensor] = useState(null)
    const handleStartEditSensor = (item,index) => () => {
        setIsEditingSensor(index)
    }
    const [isEditingThreshold, setIsEditingThreshold] = useState(false)
    const handleStartEditThreshold = () => {
        setIsEditingThreshold(true)
    }
    const handleDeleteSensor = (item,index) => async () => {
        const updatedSensors = towerCraneDangerZoneConfig.value.sensors.filter((sensor, i) => i !== index)
        const newConfig = {
            value: {
                ...towerCraneDangerZoneConfig.value,
                sensors: updatedSensors
            }
        }
        const res = await editConfigRecord(props.token.token, towerCraneDangerZoneConfig._id, newConfig)
        if (res.errno) return alert(res.message || 'Error')
        fetchConfigWithKey()
    }
    return (
        <div className={"flex-col bg-[#0C0D14] flex-1 text-[14px] h-full" + (isHoverChart ? ' overflow-hidden' : ' overflow-auto')}>
            {popType === 'date' && <div className='fixed inset-0 flex justify-center items-center' style={{ backdropFilter: 'blur(5px)', zIndex: 99 }}>
                <div className='p-[24px] bg-[#363636B2] rounded-[8px] flex flex-col text-white relative max-h-[95%] min-w-[350px]' style={{ border: '.5px solid #FFFFFF80', overflowY: 'auto' }}>
                    <div className='flex flex-row items-center space-between w-full'>
                        <div className='font-bold'>Select a date range*</div>
                    </div>
                    <div className='absolute top-[24px] right-[24px] font-bold ml-20 cursor-pointer select-none' onClick={() => { setPopType(false) }}>X</div>
                    <div className='flex flex-row my-4 w-full justify-around'>
                        <div className='w-[50px]'>From:</div>
                        <input type='date' defaultValue={filterFrom} max={filterTo || yearMonthDay(new Date())} onChange={(e) => { handleParamChange('from', e.target.value) }} className='border rounded-full px-2  min-w-[180px]' style={{ colorScheme: 'dark' }}></input>
                    </div>
                    <div className='flex flex-row mb-4 w-full justify-around'>
                        <div className='w-[50px]'>To:</div>
                        <input type='date' defaultValue={filterTo} min={filterFrom || undefined} onChange={(e) => { handleParamChange('to', e.target.value) }} className='border rounded-full px-2  min-w-[180px]' style={{ colorScheme: 'dark' }}></input>
                    </div>
                    <div className='w-full flex flex-row items-center justify-between gap-2'>
                        <div className='button_blue w-[50%]' onClick={() => { setPopType(false) }}>Confirm</div>
                        <div className='button_blue w-[50%] text-white' onClick={() => { handleParamChange('clearDate') }}>Clear</div>
                    </div>
                </div>
            </div>}
            <div style={{ ...LEFTRIGHT_PADDING }}>
                <div className="flex flex-row mt-[40px]">
                    <TitleLeftSvg className='mr-[9px]' />
                    <div className="text-[24px] text-white font-bold ">Tower Crane</div>
                </div>
                <div className="flex flex-row justify-between items-center text-white">
                    <div className="flex flex-row mt-[27px]">

                    </div>
                    <DropDown value={(filterFrom && filterTo ? `${filterFrom} / ${filterTo}` : filterDate)} select={handleDateChange} />
                </div>

                {/*chart*/}
                <div className="flex flex-col w-full mt-[25px] text-[14px]" style={{ border: '1px solid #FFFFFF80' }}>
                    <div className="flex flex-row items-center justify-between py-[24px] px-[16px]">
                        <div className="text-white text-[18px] font-bold flex items-center gap-2">
                            {/* <TitleLeftSvg className='mr-[9px]'/>  */}
                            Tower Crane Alert <CopyLink />
                        </div>
                    </div>
                    <div className="px-[26px] pt-[13px] w-full" onMouseEnter={() => setisHoverChart(true)} onMouseLeave={() => { setisHoverChart(false) }}>
                        <DangerZoneWatchChart  type={'watch-tower-crane-danger-zone'} />
                    </div>
                </div>
                {/*chart*/}

                <div className="flex flex-col w-full mt-[25px] text-[14px]" style={{ border: '1px solid #FFFFFF80' }}>
                    <div className="flex flex-row items-center justify-between py-[24px] px-[16px]">
                        <div className="text-white text-[18px] font-bold flex items-center gap-2">
                            Tower Crane Sensors
                        </div>
                        <div className="text-white button_blue" onClick={handleStartEditThreshold}> Distance Threshold: {towerCraneDangerZoneConfig?.value?.distanceThreshold || 0}</div>
                        <div className="cursor-pointer text-white font-bold text-[24px]" onClick={handleStartAddSensor}>+</div>
                    </div>
                    <div className="flex flex-row py-[6px]" style={{ borderBottom: '1px solid #FFFFFF80' }}>
                        <div className="table_header" style={{ flex: 1, color: '#fff' }}>
                            Sensor ID
                        </div>
                        <div className="table_header" style={{ flex: 1, color: '#fff' }}>
                            Sensor Name
                        </div>
                        <div className="table_header" style={{ flex: 1, color: '#fff' }}>
                            Status
                        </div>
                        <div className="table_header" style={{ width: '230px', color: '#fff' }}>
                            Last Updated
                        </div>
                        <div className="mr-[8px] w-[100px]"></div>
                        <div className="mr-[8px] w-[100px]"></div>
                    </div>
                    {towerCraneDangerZoneConfig?.value?.sensors?.length > 0 ? towerCraneDangerZoneConfig.value.sensors.map((item, index) => (
                        <div key={index} className="flex flex-row table_row">
                            <div className="flex-1 table_item" style={{ color: '#fff' }}>
                                {item.sensorId}
                            </div>
                            <div className="flex-1 table_item" style={{ color: '#fff' }}>
                                {item.sensorName}
                            </div>
                            <div className="flex-1 table_item" style={{ color: '#fff' }}>
                                <div className="py-[4px] px-[16px] rounded-[20px]" style={{backgroundColor: item.status === 'ACTIVE' ? '#40aa4080' : '#ffffff50'}}>{item.status}</div>
                            </div>
                            <div className="table_item" style={{ width: '230px', color: '#fff' }}>
                                {item.lastUpdated ? new Date(item.lastUpdated).toLocaleString() : 'N/A'}
                            </div>
                            <div className="button_blue mr-[8px] w-[100px]" onClick={handleStartEditSensor(item,index)}>
                                edit
                            </div>
                            <div className="button_white mr-[8px] w-[100px]" onClick={handleDeleteSensor(item,index)}>
                                delete
                            </div>
                        </div>
                    )) : <div className="flex flex-row py-[6px]" style={{ borderBottom: '1px solid #FFFFFF80' }}>
                        <div className="flex-1 text-center" style={{ color: '#fff' }}>
                            No sensor data
                        </div>
                    </div>}
                </div>

                {/*event list*/}
                <div className="flex flex-col mt-[48px] w-full text-[14px] mb-10 text-white" style={{ border: '1px solid #FFFFFF80' }}>
                    <div className="px-[24px] pt-[13px] flex flex-row items-center justify-between">
                        <div />
                        <div className="flex flex-row gap-2">
                            <div className="rounded-full flex flex-row items-center justify-between max-w-[225px] px-[16px] py-[2px]" style={{ borderColor: '#FFFFFF80', borderWidth: 1 }}>
                                <SmallSearchSvg className='mr-[12px]' />
                                <input defaultValue={filterName || ''} onChange={(e) => handleParamChange('search', e.target.value)} className="bg-transparent h-[21px] text-white min-w-0 outline-none" placeholder="Serial No. or Name"></input>
                            </div>
                        </div>
                    </div>
                    <DangerZoneWatchAlertList alertArr={ChartData} fetchData={fetchData}/>
                </div>
                <PageSelector page={page} total={totalItem} totalPage={totalPage} handleSelectPage={handleSelectPage} />
                <div className="flex flex-row items-center justify-end pb-[12px]">
                    <div onClick={handleResolveAll} className="gap-[8px] px-[16px] py-[4px] rounded-[16px] border select-none cursor-pointer border-[#222] text-[#222]">Resolve All</div>
                </div>
            </div>

            {isAddingSensor && <div className='fixed inset-0 flex justify-center items-center' style={{ backdropFilter: 'blur(5px)', zIndex: 99 }}>
                <div className='p-[24px] bg-[#363636B2] rounded-[8px] flex flex-col text-white relative max-h-[95%] min-w-[350px]' style={{ border: '.5px solid #FFFFFF80', overflowY: 'auto' }}>
                    <div className='flex flex-row items-center space-between w-full'>
                        <div className='font-bold'>Add Tower Crane Sensor</div>
                    </div>
                    <div className='absolute top-[24px] right-[24px] font-bold ml-20 cursor-pointer select-none' onClick={() => setIsAddingSensor(false)}>X</div>
                    <div className='flex flex-row my-4 w-full justify-around'>
                        <div className='w-[80px]'>Sensor ID:</div>
                        <input value={newSensor.sensorId} onChange={(e) => setNewSensor({ ...newSensor, sensorId: e.target.value })} className='border rounded-full px-2  min-w-[180px]' style={{ colorScheme: 'dark' }}></input>
                    </div>
                    <div className='flex flex-row my-4 w-full justify-around'>
                        <div className='w-[80px]'>Sensor Name:</div>
                        <input value={newSensor.sensorName} onChange={(e) => setNewSensor({ ...newSensor, sensorName: e.target.value })} className='border rounded-full px-2  min-w-[180px]' style={{ colorScheme: 'dark' }}></input>
                    </div>
                    <div className='flex flex-row my-4 w-full justify-around'>
                        <div className='w-[80px]'>Name:</div>
                        <input value={newSensor.sensorName} onChange={(e) => setNewSensor({ ...newSensor, sensorName: e.target.value })} className='border rounded-full px-2  min-w-[180px]' style={{ colorScheme: 'dark' }}></input>
                    </div>
                    <div className='flex flex-row my-2 w-full justify-around'>
                        <div className='w-[80px]'>Status:</div>
                        {newSensor.status === 'ACTIVE' ? (
                            <div className='button_blue w-[50%] text-center' onClick={() => setNewSensor({ ...newSensor, status: 'SLEEP' })}>ACTIVE</div>
                        ) : (
                            <div className='button_blue w-[50%] text-center' onClick={() => setNewSensor({ ...newSensor, status: 'ACTIVE' })}>SLEEP</div>
                        )}
                    </div>
                    <div className='w-full flex flex-row items-center justify-end gap-2 mt-5'>
                        <div className='button_blue' onClick={handleConfirmAddSensor}>Confirm</div>
                    </div>
                </div>
            </div>}
            {isEditingSensor !== null && <div className='fixed inset-0 flex justify-center items-center' style={{ backdropFilter: 'blur(5px)', zIndex: 99 }}>
                <div className='p-[24px] bg-[#363636B2] rounded-[8px] flex flex-col text-white relative max-h-[95%] min-w-[350px]' style={{ border: '.5px solid #FFFFFF80', overflowY: 'auto' }}>
                    <div className='flex flex-row items-center space-between w-full'>
                        <div className='font-bold'>Edit Tower Crane Sensor</div>
                    </div>
                    <div className='absolute top-[24px] right-[24px] font-bold ml-20 cursor-pointer select-none' onClick={() => {
                        setIsEditingSensor(null)
                        fetchConfigWithKey()
                        }}>X</div>
                    <div className='flex flex-row my-4 w-full justify-around'>
                        <div className='w-[80px]'>Sensor ID:</div>
                        <input value={towerCraneDangerZoneConfig.value.sensors[isEditingSensor].sensorId} onChange={(e) => {
                            const updatedSensors = [...towerCraneDangerZoneConfig.value.sensors]
                            updatedSensors[isEditingSensor] = { ...updatedSensors[isEditingSensor], sensorId: e.target.value }
                            setTowerCraneDangerZoneConfig({ ...towerCraneDangerZoneConfig, value: { ...towerCraneDangerZoneConfig.value, sensors: updatedSensors } })
                        }} className='border rounded-full px-2  min-w-[180px]' style={{ colorScheme: 'dark' }}></input>
                    </div>
                    <div className='flex flex-row my-4 w-full justify-around'>
                        <div className='w-[80px]'>Sensor Name:</div>
                        <input value={towerCraneDangerZoneConfig.value.sensors[isEditingSensor].sensorName} onChange={(e) => {
                            const updatedSensors = [...towerCraneDangerZoneConfig.value.sensors]
                            updatedSensors[isEditingSensor] = { ...updatedSensors[isEditingSensor], sensorName: e.target.value }
                            setTowerCraneDangerZoneConfig({ ...towerCraneDangerZoneConfig, value: { ...towerCraneDangerZoneConfig.value, sensors: updatedSensors } })
                        }} className='border rounded-full px-2  min-w-[180px]' style={{ colorScheme: 'dark' }}></input>
                    </div>
                    <div className='flex flex-row my-2 w-full justify-around'>
                        <div className='w-[80px]'>Status:</div>
                        {towerCraneDangerZoneConfig.value.sensors[isEditingSensor].status === 'ACTIVE' ? (
                            <div className='button_blue w-[50%] text-center' onClick={() => {
                                const updatedSensors = [...towerCraneDangerZoneConfig.value.sensors]
                                updatedSensors[isEditingSensor] = { ...updatedSensors[isEditingSensor], status: 'SLEEP' }
                                setTowerCraneDangerZoneConfig({ ...towerCraneDangerZoneConfig, value: { ...towerCraneDangerZoneConfig.value, sensors: updatedSensors } })
                            }}>ACTIVE</div>
                        ) : (
                            <div className='button_blue w-[50%] text-center' onClick={() => {
                                const updatedSensors = [...towerCraneDangerZoneConfig.value.sensors]
                                updatedSensors[isEditingSensor] = { ...updatedSensors[isEditingSensor], status: 'ACTIVE' }
                                setTowerCraneDangerZoneConfig({ ...towerCraneDangerZoneConfig, value: { ...towerCraneDangerZoneConfig.value, sensors: updatedSensors } })
                            }}>SLEEP</div>
                        )}
                    </div>
                    <div className='w-full flex flex-row items-center justify-end gap-2 mt-5'>
                        <div className='button_blue' onClick={async () => {
                            const res = await editConfigRecord(props.token.token, towerCraneDangerZoneConfig._id, { value: { ...towerCraneDangerZoneConfig.value }, lastUpdated: new Date().getTime() })
                            if (res.errno) return alert(res.message || 'Error')
                            setIsEditingSensor(null)
                            fetchConfigWithKey()
                        }}>Confirm</div>
                    </div>
                </div>
            </div>}

            {isEditingThreshold && <div className='fixed inset-0 flex justify-center items-center' style={{ backdropFilter: 'blur(5px)', zIndex: 99 }}>
                <div className='p-[24px] bg-[#363636B2] rounded-[8px] flex flex-col text-white relative max-h-[95%] min-w-[350px]' style={{ border: '.5px solid #FFFFFF80', overflowY: 'auto' }}>
                    <div className='flex flex-row items-center space-between w-full'>
                        <div className='font-bold'>Edit Distance Threshold</div>
                    </div>
                    <div className='absolute top-[24px] right-[24px] font-bold ml-20 cursor-pointer select-none' onClick={() => {
                        setIsEditingThreshold(false)
                        fetchConfigWithKey()
                        }}>X</div>
                    <div className='flex flex-row my-4 w-full justify-around'>
                        <div className='w-[80px]'>Distance:</div>
                        <input type="number" value={towerCraneDangerZoneConfig.value.distanceThreshold} onChange={(e) => {
                            setTowerCraneDangerZoneConfig({ ...towerCraneDangerZoneConfig, value: { ...towerCraneDangerZoneConfig.value, distanceThreshold: e.target.value } })
                        }} className='border rounded-full px-2  min-w-[180px]' style={{ colorScheme: 'dark' }}></input>
                    </div>
                    <div className='w-full flex flex-row items-center justify-end gap-2 mt-5'>
                        <div className='button_blue' onClick={async () => {
                            const res = await editConfigRecord(props.token.token, towerCraneDangerZoneConfig._id, { value: { 
                                ...towerCraneDangerZoneConfig.value ,
                                distanceThreshold: parseInt(towerCraneDangerZoneConfig.value.distanceThreshold)
                            } })
                            if (res.errno) return alert(res.message || 'Error')
                            setIsEditingThreshold(false)
                            fetchConfigWithKey()
                        }}>Confirm</div>
                    </div>
                </div>
            </div>
            }
        </div>
    )
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(SmartWatch)